import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiUsers, FiBookOpen, FiArrowRight } = FiIcons;

export default function CourseOverview({
  course,
  selectedId,
  onSelect,
  completedLearningUnitIds,
  progressStatus,
  completedCount
}) {
  return (
    <div className="space-y-6">
      <section className="rounded-2xl bg-gradient-to-br from-blue-900 to-blue-700 p-6 text-white md:p-8">
        <div className="flex flex-wrap items-center gap-3 text-sm text-blue-100">
          <span className="rounded-full bg-white/15 px-3 py-1">Bedriftskurs · {course.version}</span>
          <span className="inline-flex items-center gap-2"><SafeIcon icon={FiClock} /> {course.duration}</span>
        </div>
        <h2 className="mt-5 max-w-3xl text-2xl font-bold text-white md:text-3xl">{course.title}</h2>
        <p className="mt-3 max-w-3xl text-sm leading-6 text-blue-50">
          Praktisk opplæring i kartlegging, risikovurdering, tiltak og oppfølging – med tydelig skille mellom faglig vurdering og compliance.
        </p>
        <div className="mt-6 flex flex-wrap gap-x-6 gap-y-3 text-sm text-blue-50">
          <span className="inline-flex items-center gap-2"><SafeIcon icon={FiUsers} /> {course.audience}</span>
          <span className="inline-flex items-center gap-2"><SafeIcon icon={FiBookOpen} /> 10 moduler · slutt-test med 15 spørsmål</span>
        </div>
      </section>

      <div className="rounded-2xl border border-sky-200 bg-sky-50 p-4 text-sm leading-6 text-sky-900">
        {progressStatus === 'loading' && 'Henter Academy-fremdrift fra påmeldingen din.'}
        {progressStatus === 'ready' && `${completedCount} av 10 moduler fullført. Fremdriften lagres i Academy.`}
        {progressStatus === 'error' && 'Fremdrift krever en aktiv Academy-påmelding og innlogget bruker.'}
      </div>

      <section className="grid gap-3 md:grid-cols-2">
        {course.modules.map((module) => {
          const completed = completedLearningUnitIds?.has(module.learningUnitId);

          return (
            <button
              key={module.id}
              type="button"
              onClick={() => onSelect(module.id)}
              className={`rounded-2xl border p-5 text-left transition-all ${
                selectedId === module.id
                  ? 'border-blue-400 bg-blue-50 shadow-sm'
                  : 'border-slate-200 bg-white hover:border-blue-200'
              }`}
            >
              <span className="text-xs font-bold uppercase tracking-wider text-blue-700">
                Modul {module.displayOrder} · {module.duration} min
              </span>
              <span className="mt-2 block font-bold text-slate-900">{module.title}</span>
              <span className="mt-2 block text-sm leading-5 text-slate-600">{module.objective}</span>
              <span className={`mt-3 block text-sm font-semibold ${completed ? 'text-emerald-700' : 'text-slate-500'}`}>
                {completed ? 'Fullført' : 'Ikke fullført'}
              </span>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-blue-700">
                Åpne modul <SafeIcon icon={FiArrowRight} />
              </span>
            </button>
          );
        })}
      </section>
    </div>
  );
}